export default "__VITE_PUBLIC_ASSET__84403d85__"